export default function clearObject(obj, value) {
  Object.keys(obj).forEach((key) => {
    obj[key] = value;
  });
}
